import { createApp } from 'vue';
import Home from './Home.vue';
import router from './router';

import 'ant-design-vue/dist/antd.css';
import '@/assets/style/index.scss';

import './init';

import store from '@/util/store';

// 初始化日志系统
import logger, { logManager } from '@/util/logger';

// 记录应用启动
logger.info('应用启动', {
    env: process.env.NODE_ENV,
    timestamp: new Date().toISOString()
});

// 全局抑制ResizeObserver错误
const resizeObserverErrorHandler = (e) => {
    const message = e.message || (e.error && e.error.message) || '';
    if (message.includes('ResizeObserver loop') ||
        message.includes('ResizeObserver loop completed with undelivered notifications')) {
        return true; // 阻止错误冒泡
    }
    return false;
};

// 抑制全局error事件
window.addEventListener('error', (e) => {
    if (resizeObserverErrorHandler(e)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }
}, true); // 使用捕获阶段

// 抑制未处理的Promise rejection
window.addEventListener('unhandledrejection', (e) => {
    const reason = e.reason || {};
    const message = reason.message || String(reason);
    if (message.includes('ResizeObserver loop')) {
        e.preventDefault();
        return false;
    }
});

// 抑制控制台中的ResizeObserver错误
const originalConsoleError = console.error;
console.error = (...args) => {
    const message = args[0] ? args[0].toString() : '';
    if (message.includes('ResizeObserver loop')) {
        return;
    }
    originalConsoleError.apply(console, args);
};

// 抑制控制台中的ResizeObserver警告
const originalConsoleWarn = console.warn;
console.warn = (...args) => {
    const message = args[0] ? args[0].toString() : '';
    if (message.includes('ResizeObserver loop')) {
        return;
    }
    originalConsoleWarn.apply(console, args);
};

// router.afterEach((to,from,failure)=>{
//     console.log(to);
// })

const app = createApp(Home);

// 配置全局错误处理
app.config.errorHandler = (err, vm, info) => {
    console.error('=== Vue 全局错误 ===');
    console.error('错误对象:', err);
    console.error('错误消息:', err.message);
    console.error('错误堆栈:', err.stack);
    console.error('错误信息:', info);
    console.error('组件名称:', vm?.$options.name || 'unknown');
    console.error('==================');

    // 注意：不要传递完整的 err 对象给 logger，
    // 因为 loglevel 内部使用 lodash 序列化时会与 Vue 响应式对象冲突
    logger.error('Vue 全局错误', {
        errorMessage: String(err.message || err),
        errorStack: String(err.stack || ''),
        errorName: String(err.name || ''),
        errorInfo: String(info || ''),
        componentName: String(vm?.$options.name || 'unknown')
    });
};

// 路由导航日志
router.beforeEach((to, from, next) => {
    logger.debug('路由导航', {
        from: from.path,
        to: to.path
    });
    next();
});

// 将日志器添加到全局属性，方便在组件中使用
app.config.globalProperties.$logger = logger;
app.config.globalProperties.$logManager = logManager;

app.use(store).use(router).mount('#app');

logger.info('应用挂载完成');
